"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = exports.roundByCurrency = exports.formatUnit = exports.formatPrice = exports.getCurrentBreakpoint = exports.getBreakpointValue = void 0;
const i18n_1 = require("../i18n");
const resolveConfig_1 = __importDefault(require("tailwindcss/resolveConfig"));
const tailwind_config_1 = __importDefault(require("../../../tailwind.config"));
const { theme } = (0, resolveConfig_1.default)(tailwind_config_1.default);
const getBreakpointValue = (value) => {
    // @ts-ignore
    return +theme.screens[value].slice(0, 
    // @ts-ignore
    theme.screens[value].indexOf('px'));
};
exports.getBreakpointValue = getBreakpointValue;
const getCurrentBreakpoint = () => {
    let currentBreakpoint = 'sm';
    let biggestBreakpointValue = 0;
    // @ts-ignore
    for (const breakpoint of Object.keys(theme.screens)) {
        const breakpointValue = (0, exports.getBreakpointValue)(breakpoint);
        if (breakpointValue > biggestBreakpointValue && window.innerWidth >= breakpointValue) {
            biggestBreakpointValue = breakpointValue;
            currentBreakpoint = breakpoint;
        }
    }
    // @ts-ignore
    return currentBreakpoint;
};
exports.getCurrentBreakpoint = getCurrentBreakpoint;
;
const priceConfig = {
    'HUF': {
        style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 0, currencyDisplay: 'code', currency: 'HUF'
    },
    'EUR': {
        style: 'currency', minimumFractionDigits: 2, maximumFractionDigits: 2, currencyDisplay: 'code', currency: 'EUR'
    },
    'RSD': {
        style: 'currency', minimumFractionDigits: 2, maximumFractionDigits: 2, currencyDisplay: 'code', currency: 'RSD'
    },
    'USD': {
        style: 'currency', minimumFractionDigits: 2, maximumFractionDigits: 2, currencyDisplay: 'code', currency: 'USD'
    },
    'RON': {
        style: 'currency', minimumFractionDigits: 2, maximumFractionDigits: 2, currencyDisplay: 'code', currency: 'LEI'
    },
};
const formatPrice = (price, currency, options = {}) => {
    if ('undefined' !== typeof options.vatPercent && 0 < options.vatPercent) {
        price = price * (1 + options.vatPercent / 100);
    }
    if ('undefined' === typeof options.locale) {
        options.locale = i18n_1.i18n.locale.value;
    }
    let formatOptions;
    if (currency in priceConfig) {
        formatOptions = priceConfig[currency];
    }
    if ('numberFormat' in options) {
        formatOptions = Object.assign(formatOptions, options.numberFormat);
    }
    return price.toLocaleString(options.locale, formatOptions);
};
exports.formatPrice = formatPrice;
const formatUnit = (number, options = {}) => {
    if ('undefined' === typeof options.locale) {
        options.locale = i18n_1.i18n.locale.value;
    }
    let formatOptions = {};
    if ('numberFormat' in options) {
        formatOptions = Object.assign(formatOptions, options.numberFormat);
    }
    let ret = number.toLocaleString(options.locale, formatOptions);
    if (options.unit) {
        ret = ret + ' ' + options.unit;
    }
    return ret;
};
exports.formatUnit = formatUnit;
const roundByCurrency = (number, currency) => {
    let decimals = 0;
    if (currency in priceConfig) {
        decimals = priceConfig[currency].minimumFractionDigits;
    }
    const factor = Math.pow(10, decimals);
    return Math.round(number * factor) / factor;
};
exports.roundByCurrency = roundByCurrency;
//Format JS Date object to common used database standard YYYY-MM-DD format string
const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
exports.formatDate = formatDate;
